
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"_Слой_1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","width":"145","height":"49","viewBox":"0 0 671 199.7"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"st0",attrs:{"d":"M63.3 45.4L22.8 155.1h37.7l4-12.8H104l3.9 12.8h37.7L105.1 45.4H63.3zm10 68L84.2 78l10.9 35.4H73.4zM364.3 43.6c-33.9 0-60 23-60 56.8s26.2 56.8 60 56.8 60-23 60-56.8-26.2-56.8-60-56.8zm0 84.2c-16 0-26.3-12.2-26.3-27.5s10.4-27.5 26.3-27.5 26.3 12.2 26.3 27.5-10.4 27.5-26.3 27.5zM436.2 155.1h33.2v-40.9h48.9v-29h-48.9V74.4h50v-29h-83.2v109.7zM527.7 74.4h29.4v80.7h33.2V74.4h29.3v-29h-91.9v29z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M311.4 45.3h-34.9l-42.3 59.8-66.7 94.6h34.9l50.1-71.5.1.2 19.4 26.1h36.2L269.9 104l41.5-58.7zM183.1 155.3l42.2-59.7L292.7 0h-35l-50.6 72-19.5-26.1h-36.2l38.3 50.6-41.6 58.8h35zM633.9 9.6c-7.9 0-14.3 6.3-14.3 14.3s6.4 14.3 14.3 14.3 14.3-6.4 14.3-14.3-6.3-14.3-14.3-14.3zm0 26.7c-6.9 0-12.4-5.6-12.4-12.4s5.5-12.3 12.4-12.3 12.3 5.5 12.3 12.3-5.5 12.4-12.3 12.4z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M640.3 20.7c0-3-2.4-5-5.2-5h-6.7v16.4h2.2v-6.5h3l4.2 6.5h2.7l-4.4-6.5c.9 0 4.2-1.2 4.2-4.9zm-9.7 3v-6.1h4.5c1.7 0 3 1.3 3 3.1s-1.3 3-3 3h-4.5z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/img/LogoAxoft.svg